<video #player class="video-js vjs-fluid vjs-big-play-centered"></video>
